/** True when app runs inside parent iframe (cross-origin safe). */
export function isInIframe(): boolean {
  if (typeof window === 'undefined') return false;

  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
}

/** True for UAT builds (`vite build --mode uat`). */
export function isUatEnvironment(): boolean {
  return import.meta.env.MODE === 'uat';
}
